import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#b8975a",
            text: "#fff",
        },
        secondary: {
            main: "#F2E6CA",
            text: "#000",
            description: '#191F2B'
        },
        background: {
            default: "#F6F5EDDB",
            section: "#f7f7f7",
            card: '#FEFEFE'
        },
        boxShadow: "0px 2px 5px 0px #0000001A"
    },
    typography: {
        fontWeight: '600',
        h1: {
            fontWeight: 'bold'
        },
        h2: {
            fontWeight: 'bold'
        },
        h3: {
            fontWeight: 'bold'
        },
        h4: {
            fontWeight: 'bold'
        },
        h5: {
            fontWeight: 'bold'
        },
        h6: {
            fontWeight: 'bold'
        },
    },
});

export default theme;
